import { forwardRef, useMemo } from 'react';

import { RiErrorWarningLine } from 'react-icons/ri';

import {
  FileInputProps as MantineFileInputProps,
  FileInput as MantineFileInput
} from '@mantine/core';
import { InputLoader } from '@ui/feedback';

import { useMergeClassNames } from '../../utils';

import { FileInputOverrideClassnames } from './FileInput.styles';

interface FileInputProps extends MantineFileInputProps {
  loading?: boolean;
}

const FileInput = forwardRef<HTMLButtonElement, FileInputProps>((props, ref) => {
  const { size = 'md', error, loading, rightSection, classNames, ...rest } = props;

  const rightSectionFinal = loading ? (
    <InputLoader size={size} />
  ) : error ? (
    <RiErrorWarningLine />
  ) : rightSection ? (
    rightSection
  ) : undefined;

  const classes = useMemo(() => {
    return {
      ...FileInputOverrideClassnames({
        size,
        error,
        rightSection: rightSectionFinal
      })
    };
  }, [size, error, rightSectionFinal]);

  const mergedClassNames = useMergeClassNames({
    classNames: [classes, classNames]
  });

  return (
    <MantineFileInput
      {...rest}
      ref={ref}
      size={size}
      error={error}
      rightSection={rightSectionFinal}
      classNames={mergedClassNames}
    />
  );
});

export { FileInput };
export type { FileInputProps };
